import cx from 'classnames'
import Styles from './ColorChangeButton.module.scss'

interface Props {
  'aria-label'?: (color: string) => string
  active: boolean
  color: string
  onClick: () => void
  stopPropagation?: boolean
}

export const ColorChangeButton = ({
  'aria-label': ariaLabel,
  active,
  color,
  onClick,
  stopPropagation = true,
}: Props) => {
  const gradientColor = color.startsWith('linear-gradient')

  return (
    <div
      className={cx(Styles.wrapper, {
        [Styles.activeColor]: active,
        [Styles.gradientColor]: gradientColor,
      })}
    >
      <button
        aria-label={ariaLabel?.(color) || `Change text color to ${color}`}
        className={Styles.colorButton}
        data-testid={`color-button-${color}`}
        onClick={(e) => {
          if (stopPropagation) e.stopPropagation()
          onClick()
        }}
        style={{ background: color }}
      />
    </div>
  )
}

export default ColorChangeButton
